import { Box, Grid, Typography } from "@mui/material";
import { Trans } from "react-i18next";
import ImagenBadge from "./ImagenBadge";

interface HeroProps {
  t: (e: string) => string;
  prefix: string;
}
export default function Hero({ t, prefix }: HeroProps) {
  return (
    <Grid container spacing={8} sx={{ alignItems: "center" }}>
      {/* Lado Izquierdo: Textos */}
      <Grid size={{ xs: 12, lg: 6 }}>
        <Box>
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              px: 2,
              py: 1,
              bgcolor: "white",
              borderRadius: 10,
              border: "1px solid #e2e8f0",
              mb: 4,
            }}
          >
            <Box
              sx={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                bgcolor: "#00E5FF",
              }}
            />
            <Typography
              variant="caption"
              sx={{
                fontWeight: 700,
                letterSpacing: 1.5,
                color: "text.secondary",
              }}
            >
              {t(`${prefix}.hero.tag`).toUpperCase()}
            </Typography>
          </Box>

          <Typography
            variant="h2"
            sx={{
              fontWeight: 800,
              color: "#0A1128",
              lineHeight: 1.1,
              mb: 3,
              fontSize: { xs: "2.5rem", md: "3.5rem" },
            }}
          >
            <Trans
              i18nKey={`${prefix}.hero.title1`}
              components={[
                <span
                  key="tech"
                  style={{
                    color: "#0056b3",
                    background: "linear-gradient(to right, #68a8de, #0056b3)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                />,
              ]}
            />
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontSize: "1.15rem",
              color: "#475569",
              lineHeight: 1.7,
              maxWidth: 500,
            }}
          >
            {t(`${prefix}.hero.description`)}
          </Typography>
        </Box>
      </Grid>

      {/* Lado Derecho: Imagen y Badge Flotante */}
      <ImagenBadge t={t} prefix={prefix} />
    </Grid>
  );
}
